module.exports = __webpack_public_path__ + "static/10-5bf72c6aae6daf58361fd09706da0794.jpeg";